import { supabaseAuthProvider } from "ra-supabase";
import { supabaseClient } from "./dataProvider/supabase";

export const authProvider = supabaseAuthProvider(supabaseClient, {});
